import { EscrowStatusEnum, InvitationStatusEnum } from 'src/graphql/schema';
import { OtherEscrowStatusEnum } from 'src/shared/constants';

import type { ISoftwareEscrowsQuery } from 'src/graphql/actions/softwareEscrow/softwareEscrows.query';

const getEscrowStatus = ({
  escrowStatus,
  escrowAgreementApproved,
  escrowTermination,
  escrowInvitationStatus,
  pendingActivation,
}: {
  escrowStatus: EscrowStatusEnum;
  escrowAgreementApproved: boolean;
  escrowTermination?: ISoftwareEscrowsQuery['softwareEscrows']['nodes'][0]['escrowTermination'];
  escrowInvitationStatus?: InvitationStatusEnum;
  pendingActivation: boolean;
}) => {
  let status: EscrowStatusEnum | OtherEscrowStatusEnum = escrowStatus;

  if (escrowInvitationStatus === InvitationStatusEnum.Rejected) status = OtherEscrowStatusEnum.Rejected;

  if (pendingActivation) status = OtherEscrowStatusEnum.ActivationProcess;

  if (escrowStatus === EscrowStatusEnum.Onboarding && escrowAgreementApproved)
    status = OtherEscrowStatusEnum.AwaitingSignature;

  if (
    [EscrowStatusEnum.Onboarding, EscrowStatusEnum.Signed, EscrowStatusEnum.Active].includes(escrowStatus) &&
    escrowTermination
  )
    status = OtherEscrowStatusEnum.TerminationRequested;

  return status;
};

export { getEscrowStatus };
